import { useContext } from 'react'
import { AuthContext } from 'src/AppContext'

const useSign = () => useContext(AuthContext)

export default useSign
